<template>
  <div class="homepage_wrap">
    <routerCom btnIndex="1" secViewName="中智鼎证V100" :changePop="changePop"/>
    <div class="imgArr">
      <div class="title">
        <span>中智鼎证</span>
        <span style="color:#bb0000;">V100</span>
      </div>
      <div style="width:80% ;margin:32px auto 0 auto;text-align: center;font-size: 14px;color: darkgray">中智鼎证V100是一款解析汽车行驶记录仪数据的专业软件，支持国标《汽车行驶记录仪》GBT19056-2012和《汽车行驶记录仪》GB/T19056-2021，服务于交通事故责任识别、司法鉴定、超速及疲劳驾驶检测等。</div>
      <div>
        <el-button :onClick="download" style="margin-top: 20px;" size="large" color="#C80000">
          <el-icon><Download /></el-icon>下载软件</el-button>
      </div>
      <img style="cursor:pointer;width: 80%;" :onClick="download" src="../../assets/img/app/V100/1.png" alt="" />
      <img src="../../assets/img/app/V100/2.png" alt="" />
      <img src="../../assets/img/home/infoBg.png" alt="" />
    </div>
  </div>
</template>

<script>
import routerCom from '../routerCom.vue'
export default {
  name: 'appInfoV100',
  components:{
    routerCom,
  },
  props: {
    isPopShow:Function
  },
  methods: {
		funRouter() {
			this.$router.push("/appCenter");
		},
    download(){
      // window.open('http://8.140.49.120/download/vdr/zdvdr_base.msi')
      alert("请联系我们获取")
    },
    changePop(isp){
      this.isPopShow(isp);
    }
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.homepage_wrap {
	width: 1280px;
	margin: auto;
  text-align: center;
}

.imgArr{
  margin-top: 48px;
  max-width: 1280px;
  margin:50px auto;
  text-align: center;
}

.imgArr img{
  margin: 32px auto 0 auto;
  max-width: 1280px;
}

.text{
  text-align: left;
  height: 100%;
}

.text .text-title{
  font-family: Noto Sans SC;
  font-size: 20px;
  font-weight: 400;
  line-height: 20px;
  color: #131313;

  margin-top: 63px;
}

.text .text-info{
  font-family: Noto Sans SC;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: #9E9E9E;

  margin-top: 20px;
}

.title{
  margin-top: 80px;
  font-size: 34px;
  //color: #bb0000;
}
</style>
